export const PURCHASE_ORDER_TYPES = {
  PACKING_RAW_MATERIAL: 'PackingRawMaterial',
  TOBACCO: 'Tobaccos',
  CIGAR: 'Cigars',
};
